/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Ward from '../Ward'
import NewWard from '../NewWard'
import EditWard from '../EditWard'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/wards',
    name: 'ward',
    component: Ward,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/wards/create',
    name: 'create-ward',
    component: NewWard,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/wards/:id/edit',
    name: 'edit-ward',
    component: EditWard,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/ward/routes/index.js